import React, { useState } from 'react';

import InTableTextArea from '../../../form-designer/controls/ssTextArea/InTableTextArea';

const EditableCell = ({ row, column: { accessor } }) => {
  const [value, setValue] = useState(row[accessor] || '');

  const handleUpdateControlValue = (value) => {
    setValue(value);

    row.editRow({ rowId: row.id, key: accessor, value });
  };

  return (
    <InTableTextArea
      value={value}
      actions={{ updateControlValue: handleUpdateControlValue }}
      className=""
      id={`${row.id}`}
      entityName=""
      fieldName={accessor}
      isEditor={false}
      isInComplexGridRow={false}
      paperMaxWidth={900}
      nuberOfRows={5}
      paperTextFieldWidth={600}
      isRunTimeTranslation={false}
      maxLength={2000}
    />
  );
};

export default EditableCell;
